<script>

import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import VoucherRecord from '@/model/dataLayer/api/Vip/VoucherRecord'
import GlobalConfig from '@/model/global/GlobalSettings'
import PageSubHeader from '@/views/widget/typography/PageSubHeader.vue'
import DisplayInfo from '@/views/AadenPages/VipPage/UserCenter/DisplayInfo.vue'
import VipUser from '@/model/dataLayer/api/Vip/VipUser'

export default {
  name: 'AllVoucher',
  components: {
    DisplayInfo,
    PageSubHeader,
    IkDataTable
  },
  data () {
    return {
      model: VoucherRecord,
      btnLoading: false,
      showDetailInfo: false,
      blInfo: {},
      currentInfo: null,
      userList: []
    }
  },
  async mounted () {
    await this.reload()
  },
  methods: {
    showDetail (item) {
      item.userName = this.userList.find(it => it.userId === item.userId).username
      this.currentInfo = item
      this.showDetailInfo = true
    },
    checkDeviceId (item) {
      if (item.usedOrderDeviceId) {
        return item.usedOrderDeviceId.toString() !== GlobalConfig.DeviceId
      } else {
        return true
      }
    },
    async reload () {
      this.userList = (await VipUser.getList(true))
    }
  }
}
</script>

<template>
  <v-container>
    <ik-data-table
      ref="table"
      :model="model"
      :use-default-action="false"
      entity-name="所有分发的优惠券"
      icon="mdi-cash-usd"
    >
      <template #item.used="{item}">
        {{ item.usedAt ? '已使用' : '未使用' }}
      </template>
      <template #item.detail="{item}">
        <v-btn
          :disabled="checkDeviceId(item)"
          color="amber lighten-4"
          elevation="0"
          @click="showDetail(item)"
        >
          {{ $t('detail') }}
        </v-btn>
      </template>
    </ik-data-table>
    <v-dialog
      v-model="showDetailInfo"
      max-width="600px"
    >
      <v-card class="pa-4">
        <div class="d-flex align-center justify-center">
          <page-sub-header>#{{ this.currentInfo?.usedOrderId ?? '暂未使用' }}</page-sub-header>
          <v-spacer />
          <v-btn
            icon
            @click="showDetailInfo = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <div class="d-flex">
          <v-card
            class="pa-4 d-flex flex-column mr-2"
            color="#eeeeee"
            elevation="0"
            width="50%"
          >
            <div class="d-flex text-body-1 font-weight-bold">
              {{ this.currentInfo?.userName }}
            </div>
            <v-spacer />
            <div class="d-flex text-body-1">
              <div>
                折扣:
              </div>
              <v-spacer />
              <div>
                {{ this.currentInfo?.discountStr }}
              </div>
            </div>
            <div class="d-flex text-body-1">
              <div>
                创建时间:
              </div>
              <v-spacer />
              <div>
                {{ this.currentInfo?.createTimestamp | beautifulTimeWithYear }}
              </div>
            </div>
            <div class="d-flex text-body-1">
              <div>
                使用时间:
              </div>
              <v-spacer />
              <div>
                {{ this.currentInfo?.usedAt | beautifulTimeWithYear }}
              </div>
            </div>
          </v-card>
          <v-spacer />
          <display-info
            :info="this.currentInfo?.voucherInfo.displayInfo"
            :width="'50%'"
          />
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style scoped>

</style>
